import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const KCenteredContentBox = styled(Box)(() => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));
